import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { Client } from "interfaces/client";

const { Types, Creators } = createActions(
  {
    request: ['payload', 'meta'],
    success: ['data', 'pagination'],
    failure: ['error'],
    reset: [],
  },
  { prefix: "EXPORT_Clients_" }
);

export interface ExportClientsState extends IState {
  data: Client[] | Record<string, any>[];
}

const INITIAL_STATE: ExportClientsState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: ExportClientsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ExportClientsState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: ExportClientsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const exportClients = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ExportClientsTypes = Types;
export const ExportClientsActions = Creators;
